/** Registers the PathFollow2D parser. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parsePathFollow2D } from './parser';
const pathFollow2DRegistration = {
    typeName: 'PathFollow2D',
    parser: parsePathFollow2D,
};
nodeRegistry.register(pathFollow2DRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map